import { Injectable } from '@angular/core';
import { ICryptoRequest } from 'src/app/shared/domain/requests/crypto.request.entity';
import { IRequestId } from 'src/app/shared/domain/id.entity';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable()
export class DealerService {

  private readonly baseUrl = `${environment.apiBaseUrl}dealers`;
  constructor(private httpClient: HttpClient) {
  }

  getSessionInfo(body: void): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + '/sessionInfo');
  }

  getManufacturers(body: void): Observable<IManufacture[]> {
    return this.httpClient.get<IManufacture[]>(this.baseUrl + '/manufacturers');
  }

  getMakes(body: IRequestId): Observable<IMake[]> {
    return this.httpClient.post<IMake[]>(this.baseUrl + '/manufacturers/makes', body);
  }

}

export interface IManufacture {
  manId: number;
  manualClaimEnabled: boolean;
  manufacture: string;
  smartPricing: boolean;
  thirdPartyClaimEnabled?: boolean;
  partSearchEnabled?: boolean;
}
export interface IMake {
  ems_make_id: number;
  make_desc:   string;
}

export interface IDashboardStatsRequest extends ICryptoRequest {
  id: number;
  manufactureId: number;
}
